import _defineProperty from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _taggedTemplateLiteral from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import initApollo from "../data/apollo";
import gql from 'graphql-tag';
var initialState = {
  viewed: {},
  requested: {},
  requestSentForOffers: {
    viewed: {},
    requested: {}
  }
};
var actionTypes = {
  VIEWED_OFFER: 'VIEWED_OFFER',
  REQUESTED_OFFER: 'REQUESTED_OFFER',
  SYNC_OFFERS: 'SYNC_OFFERS'
};
export var offerViewed = function offerViewed(offerId) {
  return function (dispatch, getState) {
    var _getState = getState(),
      _getState$user = _getState.user,
      authenticated = _getState$user.authenticated,
      enrolled = _getState$user.enrolled;
    if (authenticated && enrolled) {
      // we only care about actions of auth and enrolled users
      dispatch({
        type: actionTypes.VIEWED_OFFER,
        payload: {
          offerId: offerId
        }
      });
    }
  };
};
export var offerRequested = function offerRequested(offerId) {
  return function (dispatch, getState) {
    var _getState2 = getState(),
      _getState2$user = _getState2.user,
      authenticated = _getState2$user.authenticated,
      enrolled = _getState2$user.enrolled;
    if (authenticated && enrolled) {
      // we only care about actions of auth and enrolled users
      dispatch({
        type: actionTypes.REQUESTED_OFFER,
        payload: {
          offerId: offerId
        }
      });
    }
  };
};
export var syncOffersViewedState = function syncOffersViewedState() {
  return function (dispatch, getState) {
    var _getState3 = getState(),
      _getState3$user = _getState3.user,
      authenticated = _getState3$user.authenticated,
      enrolled = _getState3$user.enrolled;
    if (authenticated && enrolled) {
      // we only want to sync if user auth and enrolled
      dispatch({
        type: actionTypes.SYNC_OFFERS
      });
    }
  };
};
var getOfferDetails = function getOfferDetails() {
  var apollo = initApollo();
  var mcoMemberOffers = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query mcoMemberOffers {\n      mcoMemberOffers {\n        offerIdMls\n        viewed\n        requested\n      }\n    }\n  "])));
  return apollo.query({
    query: mcoMemberOffers,
    fetchPolicy: 'cache-first'
  }).then(function (_ref) {
    var data = _ref.data;
    return data.mcoMemberOffers.reduce(function (acc, val) {
      acc[val.offerIdMls] = {
        viewed: val.viewed,
        requested: val.requested
      };
      return acc;
    }, {});
  });
};
var markAsMutation = function markAsMutation(viewed, requested) {
  var apollo = initApollo();
  return apollo.mutate({
    variables: {
      input: {
        viewed: viewed,
        requested: requested
      }
    },
    mutation: gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      mutation markOffers($input: OffersToMark) {\n        markOffers(input: $input) {\n          viewed\n          requested\n        }\n      }\n    "])))
  });
};
var sync = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(state) {
    var viewed, requested, mcoOffers, viewToUpload, requestedToUpload;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            viewed = Object.keys(state.viewed);
            requested = Object.keys(state.requested);
            if (!(viewed.length !== 0 || requested.length !== 0)) {
              _context.next = 9;
              break;
            }
            _context.next = 5;
            return getOfferDetails();
          case 5:
            mcoOffers = _context.sent;
            viewToUpload = viewed.filter(function (id) {
              var offer = mcoOffers[id];
              if (!offer) {
                return true;
              }
              return !offer.viewed;
            });
            requestedToUpload = requested.filter(function (id) {
              var offer = mcoOffers[id];
              if (!offer) {
                return true;
              }
              return !offer.requested;
            });
            if (viewToUpload.length !== 0 || requestedToUpload.length !== 0) {
              markAsMutation(viewToUpload, requestedToUpload);
            }
          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function sync(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export var markAsReducer = function markAsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case actionTypes.SYNC_OFFERS:
      sync(state);
      return {
        requested: {},
        viewed: {},
        requestSentForOffers: {
          viewed: _objectSpread(_objectSpread({}, state.requestSentForOffers.viewed), state.viewed),
          requested: _objectSpread(_objectSpread({}, state.requestSentForOffers.requested), state.requested)
        }
      };
    case actionTypes.REQUESTED_OFFER:
      {
        var offerId = action.payload.offerId;
        if (state.requestSentForOffers.requested[offerId]) {
          // offer requested state already uploaded to server we can skip it
          return state;
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          requested: _objectSpread(_objectSpread({}, state.requested), {}, _defineProperty({}, offerId, true))
        });
      }
    case actionTypes.VIEWED_OFFER:
      {
        var _offerId = action.payload.offerId;
        if (state.requestSentForOffers.viewed[_offerId]) {
          // offer viewed state already uploaded to server we can skip it
          return state;
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          viewed: _objectSpread(_objectSpread({}, state.viewed), {}, _defineProperty({}, _offerId, true))
        });
      }
    default:
      return state;
  }
};